import React, { useEffect, useRef } from 'react';
import { useState } from 'react';

import axios from 'axios';
import { useAuth } from '../Auth/AuthContext';

import { Box } from '@mui/material';
import AppBarMenu from '../Components/AppBarMenu';
import ContainerOptions from '../Components/ContainerOptions';
import BottomBar from '../Components/BottomBar';

import MessageCajaMenu from '../Components/MessageCajaMenu';
import { consumeCreatedTarget, createNotificationTarget, createPersistentTarget, keepCreatedTargetForSection } from '../utils/createdRecord';
import { createNotificationDismissalController, getEffectiveNotifications, initialNotificationState, notificationCenterReducer } from '../utils/notificationCenter';
import { sessionRequestConfig } from '../utils/csrf';

const API_URL = process.env.REACT_APP_API_URL;
const ALERT_REFRESH_MS = 60000;

const getArray = (response) => {
  if (!response?.data) return [];
  return Array.isArray(response.data) ? response.data : response.data.results || [];
};

const Menu = () => {
  const { user } = useAuth();
  const areUserAdmin = user.rol === 'Administrador';
  const options = areUserAdmin ? ['Vehiculos', 'Clientes', 'Estadias', 'Tarifas', 'Mensualidades', 'Caja', 'Usuarios', 'Reportes', 'Guia'] : ['Vehiculos', 'Clientes', 'Estadias', 'Tarifas', 'Mensualidades', 'Caja', 'Usuarios', 'Guia'];

  const [option, setOption] = React.useState('Guia')
  const [numberOption, setNumberOption] = React.useState(options.indexOf('Guia'));
  const handleChangeNumberOption = (event, newValue) => { setNumberOption(newValue); };

  const [openDialongMensualidades, setOpenDialogMensualidades] = React.useState(false);
  const [notificationState, dispatchNotification] = React.useReducer(
    notificationCenterReducer,
    initialNotificationState
  );
  const fetchingNotificationsRef = useRef(false);
  const dismissalControllerRef = useRef(null);
  const [notificationError, setNotificationError] = useState('');
  const visibleNotifications = React.useMemo(
    () => getEffectiveNotifications(notificationState),
    [notificationState]
  );

  const handleClickOpenDialogMensualidades = () => { setOpenDialogMensualidades(true); };
  const handleCloseDialogMensualidades = () => { setOpenDialogMensualidades(false); };
  const handleDiscardNotification = React.useCallback(
    (item) => dismissalControllerRef.current?.(item),
    []
  );
  const [createdTarget, setCreatedTarget] = useState(null);

  const handleChangeOption = (newOption) =>  {
    if (options.includes(newOption)) {
      setCreatedTarget((current) => keepCreatedTargetForSection(current, newOption));
      setOption(newOption);
      setNumberOption(options.indexOf(newOption));
    }
  }
  const handleCreatedRecord = (targetSection, createdId, source = 'creation') => {
    const target = createPersistentTarget(targetSection, createdId, source);
    if (!target) return;
    setCreatedTarget(target);
    handleChangeOption(targetSection);
  };
  const handleSeeNotification = (targetSection, recordId) => {
    const target = createNotificationTarget(targetSection, recordId);
    if (!target) return;
    setCreatedTarget(target);
    handleChangeOption(target.targetSection);
    handleCloseDialogMensualidades();
  };
  const handleCreatedTargetConsumed = (createdId) => {
    setCreatedTarget((current) => consumeCreatedTarget(current, createdId));
  };
  const [openDialogCreateCaja, setOpenDialogCreateCaja] = useState(false);

  const [placaVehiculoCodigoDeBarras, setPlacaVehiculoCodigoDeBarras] = useState('');

  useEffect(() => {
    dispatchNotification({ type: 'reset' });
    setNotificationError('');
    dismissalControllerRef.current = createNotificationDismissalController({
      persist: (notificationKey) => axios.post(
        `${API_URL}/notificaciones/descartar/`,
        { notification_key: notificationKey },
        sessionRequestConfig()
      ),
      dispatch: dispatchNotification,
      onError: () => setNotificationError('No se pudo descartar la notificación. Intenta nuevamente.'),
    });
    return () => {
      dismissalControllerRef.current = null;
    };
  }, [user.id]);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (fetchingNotificationsRef.current) return;
      fetchingNotificationsRef.current = true;
      try {
        const response = await axios.get(`${API_URL}/alertas-mensualidades/`, {
          params: { dias: 4, limit: 100 },
          withCredentials: true,
        });
        dispatchNotification({ type: 'received', items: getArray(response) });
      } catch (error) {
        console.error('Error al cargar las notificaciones:', error);
      } finally {
        fetchingNotificationsRef.current = false;
      }
    };

    fetchNotifications();
    const interval = setInterval(fetchNotifications, ALERT_REFRESH_MS);
    return () => clearInterval(interval);
  }, [user.id]);

  useEffect(() => {
    const fetchData = async () => {
      const responseUsuarios = await axios.get(`${API_URL}/usuarios/`);
      const empleados = responseUsuarios.data.filter(empleado => empleado.rol === 'Empleado');
      const admins = responseUsuarios.data.filter(empleado => empleado.rol === 'Administrador');
  
      const responseCajas = await axios.get(`${API_URL}/cajas/`)

      if (user.rol === 'Administrador') {
        const theAdmindHaveCaja = responseCajas.data.filter(caja => {
          const adminIndex = admins.findIndex(admin => admin.id === caja.empleado);
          return adminIndex !== -1 && admins[adminIndex].nombre === user.nombre;
        }).length !== 0;

        if (!theAdmindHaveCaja) {
          const currentAdmin = admins.filter(empleado => empleado.nombre === user.nombre);
          await axios.post(`${API_URL}/cajas/`, {empleado: currentAdmin[0].id, estado: true, dinero_base: 0, nombre: 'Caja '+user.nombre+' Admin', movimientos: []})
        }
      }
      else {
        const cajaCurrentUser = responseCajas.data.filter(caja => {
          const empleadoIndex = empleados.findIndex(empleado => empleado.id === caja.empleado);
          if (empleadoIndex !== -1) {
            return empleados[empleadoIndex].nombre === user.nombre;
          }
          return false; // Si no lo encuentra, no lo filtra
        });
        cajaCurrentUser.filter(caja => caja.estado === true).length === 0 ? setOpenDialogCreateCaja(true) : setOpenDialogCreateCaja(false);
      }

    }

    fetchData();
  }, []);

  useEffect(() => {
    if (placaVehiculoCodigoDeBarras !== '') {
      handleChangeOption('Vehiculos');
    }
  }, [placaVehiculoCodigoDeBarras]);

   useEffect(() => {
      let buffer = '';
      let lastScanTime = Date.now();

      const handleKeyDown = (e) => {
        const char = e.key;

        // Reinicia buffer si ha pasado más de 100ms entre teclas
        if (Date.now() - lastScanTime > 100) {
          buffer = '';
        }

        lastScanTime = Date.now();

        if (char === 'Enter') {
          if (buffer.length > 0) {
            setPlacaVehiculoCodigoDeBarras(buffer.replace(/Shift/g, ''));
            buffer = '';
          }
        } else {
          buffer += char;
        }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Usa toda la altura de la ventana
        overflow: 'hidden', // Evita desbordes no deseados
      }}
    >

      <MessageCajaMenu open={openDialogCreateCaja} onCloseDialog={(value) => {setOpenDialogCreateCaja(value)}}/>

      {/* AppBar fijo */}
      {!openDialogCreateCaja && <AppBarMenu handleChangeOption={handleChangeOption} pages={options} numberOption={numberOption} handleChangeNumberOption={handleChangeNumberOption}/>}

      {/* Contenedor principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1, // Hace que este contenedor ocupe el espacio restante
          overflowY: 'auto', // Permite el scroll si el contenido es muy grande
          padding: 2, // Agrega un espaciado interno
          paddingTop: 0
        }}
      >
        {!openDialogCreateCaja && <ContainerOptions option={option} handleChangeOption={handleChangeOption} handleCloseDialogMensualidades={handleCloseDialogMensualidades} openDialongMensualidades={openDialongMensualidades} handleSeeNotification={handleSeeNotification} notifications={visibleNotifications} onDiscardNotification={handleDiscardNotification} notificationError={notificationError} placaVehiculoCodigoDeBarras={placaVehiculoCodigoDeBarras} createdTarget={createdTarget} onCreatedRecord={handleCreatedRecord} onCreatedTargetConsumed={handleCreatedTargetConsumed}/>}
      </Box>

      {/* BottomBar fija */}
      {!openDialogCreateCaja && <BottomBar handleClickOpenDialogMensualidades={handleClickOpenDialogMensualidades} notificationCount={visibleNotifications.length}/>}
    </Box>
  );
};

export default Menu;
